var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"admin-org-extracts"}},[_c('vue-headful',{attrs:{"title":_vm.title + (_vm.$appName ? ' | ' + _vm.$appName : '')}}),_c('ExtractJobs',{attrs:{"extracts":_vm.extracts,"name":_vm.name,"busy":_vm.busy}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }